import { EMAIL } from '@dragonfruit/constants/signupAuthType';
import * as loadingState from '@dragonfruit/constants/loadingState';

export const LOGIN = 'LOGIN';
const LOGIN_FAILED = 'LOGIN_FAILED';
const LOGIN_SUCCESS = 'LOGIN_SUCCESS';

export const FACEBOOK_LOGIN = 'FACEBOOK_LOGIN';

export const SELECT_LOGIN_TYPE = 'SELECT_LOGIN_TYPE';

export const LOGOUT = 'LOGOUT';

export const FORCE_LOGOUT = 'FORCE_LOGOUT';
export const RESET_EMAIL_UNVERIFIED = 'RESET_EMAIL_UNVERIFIED';
export const EMAIL_UNVERIFIED = 'EMAIL_UNVERIFIED';

export const UPDATE_USER_INFO = 'UPDATE_USER_INFO';
export const UPDATE_USER_INFO_SUCCESS = 'UPDATE_USER_INFO_SUCCESS';

export const GET_USER_INFO = 'GET_USER_INFO';

export const login = ({
  account,
  password,
  phoneNumber,
  countryCode,
  currentType,
}) => ({
  type: LOGIN,
  payload: {
    account,
    password,
    phoneNumber,
    countryCode,
    currentType,
  },
});

export const loginSuccess = jwt => ({
  type: LOGIN_SUCCESS,
  payload: {
    jwt,
  },
});

export const loginFailed = errorMessage => ({
  type: LOGIN_FAILED,
  payload: {
    errorMessage,
  },
});

export const facebookLogin = () => ({ type: FACEBOOK_LOGIN });
export const logout = lang => ({
  type: LOGOUT,
  payload: {
    lang,
  },
});

export const forceLogout = ({ lang, errorCode }) => ({
  type: FORCE_LOGOUT,
  payload: {
    lang,
    errorCode,
  },
});

export const resetEmailUnverified = () => ({
  type: RESET_EMAIL_UNVERIFIED,
});

export const emailUnverified = () => ({
  type: EMAIL_UNVERIFIED,
});

export const selectLoginType = loginType => ({
  type: SELECT_LOGIN_TYPE,
  payload: {
    loginType,
  },
});

export const getUserInfo = token => ({
  type: GET_USER_INFO,
  payload: { token },
});

export const updateUserInfo = token => ({
  type: UPDATE_USER_INFO,
  payload: {
    token,
  },
});

export const updateUserInfoSuccess = uiSetting => ({
  type: UPDATE_USER_INFO_SUCCESS,
  payload: {
    uiSetting,
  },
});

// reducer
const INIT_STATE = {
  token: '',
  deviceID: '',
  loadingStatus: loadingState.EMPTY,
  loginType: EMAIL,
  errorMessage: '',
  emailUnverified: false,
  headers: {},
  uiSetting: {
    canCancelSubscription: true,
  },
};

const reducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case LOGIN:
      return {
        ...state,
        loadingStatus: loadingState.LOADING,
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        token: action.payload.jwt,
        loadingStatus: loadingState.READY,
      };
    case LOGIN_FAILED:
      return {
        ...state,
        loadingStatus: loadingState.ERROR,
        token: '',
        errorMessage: action.payload.errorMessage,
      };
    case EMAIL_UNVERIFIED:
      return {
        ...state,
        emailUnverified: true,
      };
    case FACEBOOK_LOGIN:
      return {
        ...state,
        loadingStatus: loadingState.LOADING,
      };
    case LOGOUT:
      return {
        ...INIT_STATE,
      };
    case SELECT_LOGIN_TYPE:
      return {
        ...state,
        loginType: action.payload.loginType,
      };
    case FORCE_LOGOUT:
      return {
        ...INIT_STATE,
      };
    case RESET_EMAIL_UNVERIFIED:
      return {
        ...state,
        emailUnverified: INIT_STATE.emailUnverified,
      };
    case UPDATE_USER_INFO_SUCCESS:
      return {
        ...state,
        uiSetting: action.payload.uiSetting,
      };
    default:
      return state;
  }
};

export default reducer;

export const getToken = state => state.auth.token;
export const getUserIsAuthenticated = state => !!state.auth.token;
export const getDeviceID = state => state.auth.deviceID;
export const getAppsFlyerId = state => state.auth.appsflyerId;
export const getHeaders = state => state.auth.headers;
export const getCurrentType = state => state.auth.loginType;
export const getEmailUnverified = state => state.auth.emailUnverified;
export const getLoadingStatus = state => state.auth.loadingStatus;



// WEBPACK FOOTER //
// ./app/redux/auth.js